var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.contract.renewal_required)?_c('v-alert',{attrs:{"color":_vm.getBannerColor,"text":"","icon":"mdi-flag"}},[_c('span',{staticClass:"text--secondary"},[_vm._v(" "+_vm._s(_vm.contract.expiryDateMessage())+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }